import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MySubject } from './my-subject';
import { Observable } from 'rxjs';
import { GlobalsService } from './globals';

@Injectable()
export class ToolboxService {

    checkView = new MySubject();

    constructor(private http: HttpClient, private globals: GlobalsService) {

    }

    listToolbox() {
        const sub = this.http.get(`${this.globals.apiUrl}/api/organizacion/toolboxes`).subscribe((resp: any) => {
            const ckeck = this.checkToolbox(resp.data);
            this.checkView.next(ckeck);
            sub.unsubscribe();
        }, (error: any) => {
            console.error('Error al consultar lista toolbox', error);
            this.checkView.next(false);
            sub.unsubscribe();
        });
    }

    get getCheckView(): Observable<any> {
        return this.checkView.asObservable();
    }

    checkToolbox(data) {
        let ckeck = false;
        data.map((element: any) => {
            if (element.url === 'toolbox/nc') {
                if (!element.activo) {
                    // alert('No tienes licencia para usar está herramienta');
                } else if (!element.permitido) {
                    // alert('No está autorizado para usar está herramienta');
                    ckeck = true;
                } else {
                    ckeck = true;
                }
            }
        });
        return ckeck;
    }

    listMenu() {
        return this.http.get(`${this.globals.apiUrl}/api/toolbox/menu/6`);
    }
}
